import React, { useContext, useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import ClipLoader from 'react-spinners/ClipLoader';

import { NCRContext } from 'views';

const GetReplacementItems = () => {
  const { state, setState, setToasts } = useContext(NCRContext);
  const [loading, setLoading] = useState(false);

  const setSODetails = (so) => {
    const items = so.map((item) => {
      return {
        code: item.Item,
        currency: item.CurrencyCode,
        quantity: item.Qty_Shipped,
        unit_price: item.Discounted_Line_Unit_Price,
        description: item.Description,
      };
    });

    setState((prev) => ({
      ...prev,
      ncr: {
        ...prev.ncr,
        order: {
          ...prev.ncr.order,
          orderItems: items,
        },
        subsidiary: {
          ...prev.ncr.subsidiary,
          currency: so[0].CurrencyCode,
        },
      },
    }));
  };

  const removeSalesOrder = () => {
    setState((prev) => ({
      ...prev,
      ncr: {
        ...prev.ncr,
        order: {
          ...prev.ncr.order,
          orderItems: [],
        },
      },
    }));
  };

  const getSalesOrder = () => {
    const soNumber = state.ncr.original_so_number;
    setLoading(true);
    axios
      .get(`/api/item_lines/${soNumber}`)
      .then((res) => {
        setSODetails(res.data);
      })
      .catch((err) => {
        if (err) {
          setToasts((toasts) => [
            ...toasts,
            {
              message: 'Sales order not found, please try again.',
              color: 'LightPink',
            },
          ]);
        }
        setSODetails(null);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading ? (
        <Button className="import-netsuite" variant="success">
          <ClipLoader size={32} color="grey" />
        </Button>
      ) : (
        <Button
          className="import-netsuite"
          variant="success"
          onClick={getSalesOrder}
        >
          Get Original Item Lines
        </Button>
      )}
      <Button
        className="import-netsuite"
        variant="danger"
        onClick={removeSalesOrder}
      >
        Remove Original Item Lines
      </Button>
    </>
  );
};

export { GetReplacementItems };
